Oskari.clazz.define("Oskari.vapaka.bundle.products.ProductsBundleInstance",
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  this.conf = null;
  this.container = jQuery('#panel-left .inner');
  this.sandbox = null;
  this.map = null;
  this.layer = null;
  this.select = null;
  this.control = null;
  this.product = null;
  this.layers = {};
  this.lang = Oskari.getLang();
  this.selectedFeatures;
  this.translations = {
    fi: {
      no_files: 'No files',
      remove: 'Remove'
    },
    sv: {
      no_files: 'No files',
      remove: 'Remove'
    },
    en: {
      no_files: 'No files',
      remove: 'Remove'
    }
  };
}, {
  /**
  * @static
  * @property __name
  */
  __name: 'Products',
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method setSandbox
   * @param {Oskari.Sandbox} sandbox
   * Sets the sandbox reference to this component
   */
  setSandbox: function setSandbox(sandbox) {
    this.sandbox = sandbox;
  },
  /**
   * @method getSandbox
   * @return {Oskari.Sandbox}
   */
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  /**
   * @method start
   * BundleInstance protocol method
   */
  start: function start() {
    var _this = this;
    this.sandbox = Oskari.getSandbox();
    this.sandbox.register(this);
    this.map = Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule');
    this.conf = Oskari.app.appConfig.products;
    this.addSystemStuff();
    this.createUI();
    this.selectedFeatures = new Set();
    Object.keys(this.eventHandlers).forEach(function (eventName) {
      return _this.sandbox.registerForEventByName(_this, eventName);
    });
  },
  addSystemStuff: function addSystemStuff() {
    Oskari.getSandbox().postRequestByName('VectorLayerRequest', [{
      "layerId": "GRID",
      "opacity": 100,
      "hover": {
        'featureStyle': {
          'inherit': true,
          'effect': 'darken'
        }
      }
    }]);
    Oskari.getSandbox().postRequestByName('VectorLayerRequest', [{
      "layerId": "HIGHLIGHT",
      "opacity": 50
    }]);
  },
  createUI: function createUI() {
    var me = this;
    var products = this.conf.products;
    var html = '';
    for (var i = 0; i < products.length; i++) {
      html += '<li rel="' + products[i].id + '"><label title="' + products[i]['tooltip_' + me.lang] + '"><input type="checkbox"> ' + products[i]['title_' + me.lang] + '</label></li>';
    }
    this.container.html(html);
    this.container.on('click', 'li input', function () {
      var el = jQuery(this);
      if (el.prop('checked')) {
        // if one is already turned on
        if (me.product) {
          me.container.find('input').not(this).prop('checked', '');
          me.layerOff();
        }
        me.layerOn(el.closest('li').attr('rel'));
      } else {
        if (me.product !== null) {
          me.layerOff();
        }
      }
    });

    // remove selected cell
    jQuery('#panel-right ul.inner.selection').on('click', 'li a.remove', function (e) {
      e.preventDefault();
      var id = jQuery(this).closest('li').attr('rel');
      Oskari.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', ['id', id, 'HIGHLIGHT']);
      jQuery(this).parent().remove();
    });
  },
  layerOn: function layerOn(id) {
    var me = this;
    var products = this.getProductByAttr('id', id);
    this.product = products[0];
    var layer = this.getLayerByAttr('id', this.product.grid)[0];
    jQuery.ajax({
      url: layer.source,
      type: 'GET',
      cache: true,
      dataType: 'json',
      success: function success(geojson) {
        Oskari.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [geojson, {
          layerId: 'GRID',
          clearPrevious: true,
          'featureStyle': {
            "fill": {
              "color": null
            },
            "stroke": {
              "area": {
                "color": "#000000",
                "lineDash": "solid",
                "lineJoin": "miter",
                "width": 3
              },
              "color": '#00000',
              // "#FAEBD7", // fill color
              "width": 3
            },
            "text": {
              // text style
              "fill": {
                // text fill style
                "color": "#000000" // fill color
              },
              "stroke": {
                // text stroke style
                "color": "#ffffff",
                // stroke color
                "width": 1 // stroke width
              },
              "font": "bold 10px Arial",
              // font
              "textAlign": "top",
              // text align
              "oEffsetX": 12,
              // text offset x
              "oEffsetY": 12,
              // text offset y
              "labelProperty": layer.cell_identifier
            }
          }
        }]);
      },
      error: function error(e) {
        console.log(e);
      }
    });
  },
  layerOff: function layerOff() {
    Oskari.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', {
      "layerId": 'HIGHLIGHT'
    });
    Oskari.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', {
      "layerId": 'GRID'
    });
    this.selectedFeatures.clear();
    jQuery('#panel-right ul.selection').html('');
    this.product = null;
  },
  addCellToSelection: function addCellToSelection(f) {
    var me = this;
    var layer = this.getLayerByAttr('id', this.product.grid);
    layer = layer[0];
    var path = this.product.path;
    //var cell = f.attributes[layer.cell_identifier].toString();
    var cell = f.properties['numero'].toString();

    // zero based cell nubers hack
    if (layer.cell_length - cell.length > 0) {
      var z = '';
      for (var i = 0; i < layer.cell_length - cell.length; i++) z += '0';
      cell = z + cell;
    }
    if (layer.cell_length == 4) {
      path += cell.substring(0, 1) + '/' + cell;
    } else {
      // FIXME: valid only for 20k grid!!!
      path += cell.substring(0, 1) + '/' + cell.substring(0, 4) + '/' + cell;
    }
    var fc = {};
    fc.type = 'FeatureCollection';
    fc.features = [];
    fc.features.push(f);
    Oskari.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [fc, {
      layerId: 'HIGHLIGHT',
      'featureStyle': {
        "fill": {
          "color": '#ff00ff',
          // "#FAEBD7", // fill color
          "area": {
            "pattern": -1 // fill style
          }
        }
      }
    }]);
    jQuery('#panel-right').accordion({
      active: 1
    });
    var html = '<li rel="' + f.id + '"><b>' + f.properties[layer.cell_identifier] + '</b><a href="#remove" class="remove" title="' + this.translations[this.lang].remove + '"></a></li>';
    jQuery('#panel-right ul.selection').append(html);

    // ajax call to fetch files
    jQuery.ajax({
      url: me.conf.script,
      type: 'GET',
      data: {
        path: path
      },
      dataType: 'json',
      contentType: 'text/json',
      success: function success(d) {
        if (d.length == 0) {
          f.properties['disabled'] = 'true';
          jQuery('#panel-right ul.selection li[rel=' + f.id + ']').append('<ul><li class="grey">' + me.translations[me.lang].no_files + '</li></ul>');
        } else {
          me.createLinksToFiles(f, path, d);
        }
      },
      error: function error(e) {
        console.log(e);
      }
    });
  },
  removeCellFromSelection: function removeCellFromSelection(f) {
    var layer = this.getLayerByAttr('id', this.product.grid);
    layer = layer[0];
    jQuery('#panel-right').accordion({
      active: 1
    });
    jQuery('#panel-right ul.selection li[rel=' + f.id + ']').remove();
    Oskari.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', ['id', f.id, 'HIGHLIGHT']);
  },
  createLinksToFiles: function createLinksToFiles(f, path, d) {
    var layer = this.getLayerByAttr('id', this.product.grid);
    layer = layer[0];
    var html = '';
    for (var i in d) {
      html += '<li><a href="' + this.conf.download + '/' + d[i].path + '/' + d[i].file + '" target="_self" title="' + d[i].file + '">' + d[i].file + '</a></li>';
    }
    jQuery('#panel-right ul.selection li[rel=' + f.id + ']').append('<ul>' + html + '</ul>');
  },
  getProductByAttr: function getProductByAttr(attr, value) {
    var products = this.conf.products;
    var arr = [];
    for (var i = 0; i < products.length; i++) {
      if (products[i][attr] == value) arr.push(products[i]);
    }
    return arr;
  },
  getLayerByAttr: function getLayerByAttr(attr, value) {
    var layers = this.conf.grids.layers;
    var arr = [];
    for (var i = 0; i < layers.length; i++) {
      if (layers[i][attr] == value) arr.push(layers[i]);
    }
    return arr;
  },
  onEvent: function onEvent(event) {
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }

    // Skip events, if internally linked layer
    if (typeof event.getMapLayer === 'function' && event.getMapLayer().isLinkedLayer()) {
      this.plugins['Oskari.userinterface.Tile'].refresh();
      return;
    }
    return handler.apply(this, [event]);
  },
  /**
  	 * @property {Object} eventHandlers
  	 * @static
  	 */
  eventHandlers: {
    /**
     * @method AfterMapLayerRemoveEvent
     * @param {Oskari.mapframework.event.common.AfterMapLayerRemoveEvent} event
     *
     * Calls flyouts handleLayerSelectionChanged() method
     */
    'FeatureEvent': function FeatureEvent(event) {
      if (!event.getFeatures() || event.getOperation() !== "click") {
        return;
      }
      var feature = event._features[0].geojson.features[0];
      var gridCell = feature.properties['numero'];
      if (!this.selectedFeatures.has(gridCell)) {
        this.addCellToSelection(feature);
        this.selectedFeatures.add(gridCell);
      } else {
        this.removeCellFromSelection(event.getFeatures().filter(function (f) {
          return f.layerId = 'HIGHLIGHT';
        })[0].geojson.features[0]);
        this.selectedFeatures.delete(gridCell);
      }
    }
  },
  /**
  	* @method init
  	* implements Module protocol init method - does nothing atm
  	*/
  init: function init() {
    return null;
  },
  /**
   * @method stop
   * BundleInstance protocol method
   */
  stop: function stop() {},
  /**
   * @method update
   * BundleInstance protocol method
   */
  update: function update() {}
}, {
  protocol: ['Oskari.bundle.BundleInstance']
});